import React, { useState, useEffect, useCallback } from "react";
import RegularImage from "../../../images/slides/slide-b.jpg";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  PreviewCard,
  TooltipComponent,
} from "../../components/Component";
import { useNavigate } from "react-router-dom";
import FormInput from "../form-components/InputComponent";
import FormSelect from "../form-components/SelectComponent";
import FormTextArea from "../form-components/TextAreaComponent";
import { useForm, FormProvider } from "react-hook-form";
import { Col, Row, Modal, ModalBody, Alert, Spinner } from "reactstrap";
import DataTable, { TableColumn } from "react-data-table-component";
import moment from "moment";
import Swal from "sweetalert2";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import mastersServices from "../../api/masters/mastersService";
import misc from "../../api/misc/miscService";
interface RowData {
  id: string;
  uomName: string;
  uomID: string;
  category: string;
  subcategory: string;
  materialCode: string;
  materialName: string;
  description?: string;
  status: string;
  createdDate?: string;
  modifiedDate?: string;
  serialNumber?: number;
}
interface SelectOptions {
  value: string;
  label: string;
}
const MaterialLibrary: React.FC = (props) => {
  const navigate = useNavigate();
  const formMethods = useForm({
    mode: "onChange",
  });
  const [industryTypes, setIndustryTypes] = useState<SelectOptions[]>([]);
  const [uomOptions, setUomOptions] = useState<SelectOptions[]>([]);
  const [category, setCategory] = useState([]);
  const { handleSubmit, setValue, reset } = formMethods;
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [alertInfo, setAlertInfo] = useState({
    type: "", // 'success' or 'error'
    message: "",
    errors: [],
  });
  const [modal, setModal] = useState<{ add: boolean; edit: boolean }>({
    add: false,
    edit: false,
  });
  const [currentRowData, setCurrentRowData] = useState<RowData | null>(null);

  const submitForm = async (data: any) => {
    if (modal.edit && currentRowData) {
      // Handle edit form submission
      console.log("Editing row:", currentRowData);
      console.log("Form data:", data);
      const addAdminMaterial = await mastersServices.updateAdminMaterial(
        data,
        currentRowData.id
      );
      const { status, message } = addAdminMaterial;
      if (status) {
        setLoading(false);
        Swal.fire("Updated!", "Material Library has been updated", "success");
        setModal({ add: false, edit: false });
        reset();
        getAdminMaterial();
      } else {
        setLoading(false);
        let errorMessage = "An error occurred";
        const fullErrorMessage = `${errorMessage}\n${message.join(", ")}`;
        setAlertInfo({
          type: "error",
          message: fullErrorMessage,
          errors: [],
        });
      }
    } else {
      // Make API call to add the data
      setLoading(true);
      const addAdminMaterial = await mastersServices.addAdminMaterial(data);
      const { status, message } = addAdminMaterial;
      if (status) {
        setLoading(false);
        Swal.fire("Created!", "Material Library has been created", "success");
        setModal({ add: false, edit: false });
        reset();
        getAdminMaterial();
      } else {
        setLoading(false);
        let errorMessage = "An error occurred";
        const fullErrorMessage = `${errorMessage}\n${message.join(", ")}`;
        console.log("fullErrorMessage", fullErrorMessage);
        setAlertInfo({
          type: "error",
          message: fullErrorMessage,
          errors: [],
        });
      }
    }
  };

  const [rowData, setRowData] = useState<RowData[]>([]);

  const getAdminMaterial = useCallback(async () => {
    setDataLoading(true);
    try {
      const adminMaterial = await mastersServices.getAdminMaterial();

      if (adminMaterial.status && adminMaterial.data.length > 0) {
        // Add serial numbers to data
        const dataWithSerialNumbers = adminMaterial.data.map(
          (item: any, index: any) => ({
            ...item,
            serialNumber: index + 1,
          })
        );
        setRowData(dataWithSerialNumbers);
      }
    } catch (error: any) {
      console.error("Failed to fetch admin material:", error.message);
    } finally {
      setDataLoading(false);
    }
  }, []);

  const getContructionsMaterialTypes = useCallback(async () => {
    try {
      const matCats = await misc.getContructionsMaterialTypes();
      console.log(matCats);
      if (matCats.status && matCats.data.length > 0) {
        let transformedData = matCats.data.map((item: any) => ({
          value: item.name,
          label: item.name,
        }));
        setIndustryTypes(transformedData);
      }
    } catch (error: any) {
      console.error("Failed to fetch Material types:", error.message);
    }
  }, []);

  const getMaterialCategoryDropdownData = useCallback(async () => {
    try {
      const matCats = await mastersServices.getMaterialCategories();
      console.log(matCats);
      if (matCats.status && matCats.data.length > 0) {
        let transformedData = matCats.data.map((item: any) => ({
          value: item.category,
          label: item.category,
        }));
        setCategory(transformedData);
      }
    } catch (error: any) {
      console.error("Failed to fetch Categorys types:", error.message);
    }
  }, []);
  const getUOMDropDownData = useCallback(async () => {
    try {
      const uom= await mastersServices.getUOMs();
      
      if (uom.status && uom.data.length > 0) {
        let transformedData = uom.data.map((item: any) => ({
          value: item.id,
          label: item.uom_name,
        }));
        setUomOptions(transformedData);
      }
    } catch (error: any) {
      console.error("Failed to fetch UOMs types:", error.message);
    }
  }, []);

  useEffect(() => {
    getUOMDropDownData()
    getAdminMaterial();
    getContructionsMaterialTypes();
    getMaterialCategoryDropdownData();
  }, []);

  const columns: TableColumn<RowData>[] = [
    {
      name: "S.No",
      width: "100px",
      selector: (row: RowData) => row.serialNumber!,
      sortable: false,
    },
    {
      name: "Category",
      width: "150px",
      selector: (row: RowData) => row.category,
      sortable: true,
    },
    {
      name: "Material Type",
      width: "150px",
      selector: (row: RowData) => row.subcategory || "N/A",
      sortable: true,
    },
    {
      name: "Material Code",
      width: "150px",
      selector: (row: RowData) => row.materialCode,
      sortable: true,
    },
    {
      name: "Material Name",
      width: "250px",
      selector: (row: RowData) => row.materialName,
      sortable: true,
    },
    {
      name: "UOM",
      width: "150px",
      selector: (row: RowData) => row.uomName || "N/A",
      sortable: true,
    },
    {
      name: "Description",
      width: "250px",
      selector: (row: RowData) => row.description!,
      sortable: true,
      cell: (row: RowData) => {
        const description = row.description || ""; // Default to empty string if null or undefined
        const truncatedDescription =
          description.length > 20
            ? `${description.substring(0, 20)}...`
            : description;

        return (
          <div>
            <span id={`desc-tooltip-${row.id}`}>{truncatedDescription}</span>
            <TooltipComponent
              iconClass="info-circle text-info"
              icon="info"
              id={`desc-tooltip-${row.id}`}
              direction="top"
              text={description}
              containerClassName={""}
            />
          </div>
        );
      },
    },
    {
      name: "Created Date",
      width: "150px",
      selector: (row: RowData) =>
        moment(row.createdDate).format("DD MMMM YYYY"),
      sortable: true,
    },
    {
      name: "Status",
      width: "100px",
      selector: (row: RowData) => row.status,
      sortable: true,
      cell: (row: RowData) => (
        <span
          className={`tb-status text-${
            row.status === "Active" ? "success" : "danger"
          }`}
        >
          {row.status}
        </span>
      ),
    },
    {
      name: "",
      width: "90px",
      sortable: false,
      cell: (row: RowData) => (
        <DropdownTrans
          row={row}
          onEdit={() => handleEdit(row)}
          onRemove={() => handleRemove(row)}
        />
      ),
    },
  ];

  const handleEdit = (row: RowData) => {
    setAlertInfo({
      type: "", // 'success' or 'error'
      message: "",
      errors: [],
    });
    setCurrentRowData(row);
    setValue("category", row.category);
    setValue("subcategory", row.subcategory);
    setValue("materialCode", row.materialCode);
    setValue("materialName", row.materialName);
    setValue("description", row.description);
    setValue("uomID", row.uomID);
    setModal({ add: false, edit: true });
  };

  const handleRemove = (row: RowData) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Make API call to remove the data
        try {
          const deleteUOM = await mastersServices.removeAdminMaterial(row.id);
          if (deleteUOM.status) {
            Swal.fire("Deleted!", "Material has been removed.", "success");
            getAdminMaterial();
          } else {
            Swal.fire({
              icon: "error",
              title: "Error in submission",
              text: "Please contact administrator",
              focusConfirm: false,
            });
          }
        } catch (error: any) {
          console.log(error.message);
        }
      }
    });
  };

  const onFormCancel = (e: any) => {
    e.preventDefault();
    setModal({ add: false, edit: false });
    reset();
  };

  return (
    <React.Fragment>
      <Head title="Material Library" />
      <Content>
        <BlockHead size="lg">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h4">Material Library</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <ul className="nk-block-tools g-3">
                <li>
                  <Button
                    color="primary"
                    className="btn-icon"
                    onClick={() => {
                      setModal({ add: true, edit: false });
                      reset({ subcategory: "", category: "" });
                      setAlertInfo({
                        type: "", // 'success' or 'error'
                        message: "",
                        errors: [],
                      });
                    }}
                  >
                    <Icon name="plus"></Icon>
                    <span style={{marginLeft: "-18%"}}>Add </span>
                  </Button>
                </li>
              </ul>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewCard className={"cardBox"} bodyClass="card-inner-xl">
            <DataTable
              columns={columns}
              data={rowData}
              pagination
              striped
              dense
              className="custom-compact-rows"
              progressPending={dataLoading}
              progressComponent={
                <div className="p-4 text-center w-100">
                  <Spinner color="primary" />
                </div>
              }
            />
          </PreviewCard>
        </Block>
      </Content>
      <Modal
        isOpen={modal.add || modal.edit}
        toggle={() => setModal({ add: false, edit: false })}
        className="modal-dialog-centered"
        size="lg"
      >
        <ModalBody>
          <a href="#cancel" onClick={onFormCancel} className="close">
            <Icon name="cross-sm"></Icon>
          </a>
          <div className="p-2">
            <h5 className="title">
              {modal.edit ? "Edit Material" : "Add Material"}
            </h5>
            {alertInfo.message && (
              <div className="mb-3 mt-1">
                <Alert
                  color={alertInfo.type === "error" ? "danger" : "success"}
                  className="alert-icon"
                >
                  <strong>{alertInfo.message}</strong>
                  <Icon
                    name={
                      alertInfo.type === "error"
                        ? "alert-circle"
                        : "check-circle"
                    }
                  />
                  {alertInfo.errors.length > 0 ? (
                    <ul>
                      {alertInfo.errors.map((err, index) => (
                        <li key={index}>{err}</li>
                      ))}
                    </ul>
                  ) : (
                    ""
                  )}
                </Alert>
              </div>
            )}
            <div className="mt-4">
              <FormProvider {...formMethods}>
                <form
                  className="content clearfix"
                  onSubmit={handleSubmit(submitForm)}
                >
                  <Row className="gy-4">
                    <Col lg="6">
                      <FormSelect
                        name="subcategory"
                        label="Material Type"
                        options={industryTypes}
                        required={true}
                        placeholder="-Select-"
                      />
                    </Col>
                    <Col lg="6">
                      <FormSelect
                        name="category"
                        label="Category"
                        options={category}
                        required={true}
                        placeholder="-Select-"
                      />
                    </Col>
                    <Col lg="6">
                      <FormSelect
                        name="uomID"
                        label="UOM"
                        options={uomOptions}
                        required={true}
                        placeholder="-Select-"
                      />
                    </Col>
                    <Col lg="6">
                      <FormInput
                        name="materialCode"
                        label="Material Code"
                        required={true}
                        type="text"
                        minLength={2}
                        maxLength={30}
                        placeholder="Enter Material Code"
                      />
                    </Col>
                    <Col lg="6">
                      <FormInput
                        name="materialName"
                        label="Material Name"
                        required={true}
                        type="text"
                        minLength={2}
                        maxLength={30}
                        placeholder="Enter Material Name"
                      />
                    </Col>
                    <Col lg="12">
                      <FormTextArea
                        name="description"
                        label="Description"
                        required={true}
                        minLength={5}
                        maxLength={100}
                      />
                    </Col>
                    <Col lg="12">
                      <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                        <li>
                          <Button color="primary" size="md" type="submit">
                            Submit
                          </Button>
                        </li>
                        <li>
                          <a
                            href="#cancel"
                            onClick={onFormCancel}
                            className="link link-light"
                          >
                            Cancel
                          </a>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </form>
              </FormProvider>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

interface DropdownTransProps {
  row: RowData;
  onEdit: () => void;
  onRemove: () => void;
}

const DropdownTrans: React.FC<DropdownTransProps> = ({
  row,
  onEdit,
  onRemove,
}) => {
  return (
    <UncontrolledDropdown>
      <DropdownToggle
        tag="a"
        className="text-soft dropdown-toggle btn btn-icon btn-trigger"
      >
        <Icon name="more-h"></Icon>
      </DropdownToggle>
      <DropdownMenu end>
        <ul
          className="link-list-plain"
          style={{ paddingTop: 10, paddingBottom: 10 }}
        >
          <li>
            <DropdownItem
              tag="a"
              href="#dropdownitem"
              onClick={(ev) => {
                ev.preventDefault();
                onEdit();
              }}
            >
              <Icon name="icon ni ni-edit"></Icon>
              View/Edit
            </DropdownItem>
          </li>
          <li>
            <DropdownItem
              tag="a"
              href="#dropdownitem"
              onClick={(ev) => {
                ev.preventDefault();
                onRemove();
              }}
            >
              <Icon name="icon ni ni-na"></Icon>
              Remove
            </DropdownItem>
          </li>
        </ul>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default MaterialLibrary;
